import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'

const apiUrl = `${urlPrefix}/cruisePlan`
//#region 基本信息
const GetStatusList = `${apiUrl}/GetStatusList`
const GetList = `${apiUrl}`
const Post = `${apiUrl}`
const Put = (id: number) => `${apiUrl}/${id}`
const Get = (id: number) => `${apiUrl}/${id}`
const Delete = (id: number) => `${apiUrl}/${id}`
const Stop = (id: number) => `${apiUrl}/Stop?id=${id}`
const Open = (id: number) => `${apiUrl}/Open?id=${id}`
const RunTask = (planId: number) => `${apiUrl}/RunTask/${planId}`
const SearchUnits = `${apiUrl}/SearchUnits`
const SearchParts = (listId: number) => `${apiUrl}/SearchParts/${listId}`
const GetPositionsByUnit = (unitId: number) => `${apiUrl}/GetPositionsByUnit/${unitId}`
const GetMultiUnitPositions = `${apiUrl}/MultiUnitPositions`
const SearchUsers = (teamId: number) => `${apiUrl}/SearchUsers/${teamId}`
const GetPendingTask = (planId: number) => `${apiUrl}/GetPendingTask/${planId}`
const GetTaskList = (planId: number) => `${apiUrl}/GetTaskList/${planId}`
const Close = `${apiUrl}/Close`
//#endregion

export const emptyCruisePlan: CruisePlanData = {
    Id: 0,
    PlanName: '',
    ScheduleId: 0,
    ScheduleType: 0,
    Frequence: 0,
    IncludeHolidayDays: false,
    FromDate: new Date(),
    StartHour: '06:00',
    WorkHours: 1,
    DelayTime: 0,
    Comments: '',
    CloseReason: '',
    Status: 0,
    NewUserId: 0,
    NewDate: new Date(),
    UpdateUserId: 0,
    UpdateDate: new Date(),

    ScheduleCode: '',
    ScheduleName: '',

    ScheduleList: [],
    TeamMembers: [],
    UnitList: []
}
export interface CruisePlanData {
    [key: string]: any
    Id: number
    PlanName: string
    ScheduleId: number
    ScheduleType: number
    Frequence: number
    IncludeHolidayDays: boolean
    FromDate: Date
    StartHour: string
    WorkHours: number
    DelayTime: number
    Comments: string
    CloseReason: string
    Status: number
    NewUserId: number
    NewDate: Date
    UpdateUserId: number
    UpdateDate: Date

    ScheduleCode: string
    ScheduleName: string

    ScheduleList: CruisePlanScheduleData[]
    TeamMembers: CruisePlanTeamMemberData[]
    UnitList: CruisePlanUnitData[]
}
export interface CruisePlanScheduleData {
    [key: string]: any
    Id: number
    CruisePlanId: number
    ScheduleStart: string
    ScheduleEnd: string
    TimespanStart: number
    TimespanEnd: number
}
export interface CruisePlanTeamMemberData {
    [key: string]: any
    Id: number
    CruisePlanId: number
    //1:本级机构  2:巡防组织  3:巡查人员
    ReferType: number
    ReferName: string
    ReferId: number
    CruiserId: number
    CruiserName: string
}
export interface CruisePlanUnitData {
    [key: string]: any
    Id: number
    CruisePlanId: number
    //1.文保单位 2.单位级别 3.行政区域  4.级别&行政区域
    ObjectType: number
    LevelId: number
    CityId: number
    CountyId: number
    UnitId: number

    LevelName: string
    CityName: string
    CountyName: string
    UnitName: string

    PointList: CruisePlanUnitPointData[]
}
export interface CruisePlanUnitPointData {
    [key: string]: any
    Id: number
    CruisePlanUnitId: number
    UnitId: number
    PointId: number
    PointName: string
}
//#region 查询符合条件的文保单位
export interface CruisePlanUnitSearchFilter {
    Page: number
    PageSize: number
    LevelId: number
    CityId: number
    CountyId: number
    ClassifyIds: string
    Keyword: string
}
export interface CruisePlanUnitSearchData {
    [key: string]: any
    ListId: number
    UnitId: number
    UnitCode: string
    UnitName: string
    AreaName: string
    CityId: number
    CityName: string
    CountyId: number
    CountyName: string
    ClassId: number
    ClassName: string
    LevelId: number
    LevelName: string
    BatchId: number
    BatchName: string
}

//维护页面选择文保单位
export const searchUnits = (param: any) => {
    return tryAxios({
        method: 'get',
        url: SearchUnits,
        params: param
    })
}
export const searchParts = (listId: number) => {
    return tryAxios({
        method: 'get',
        url: SearchParts(listId)
    })
}
export const getPositionsByUnit = (unitId: number) => {
    return tryAxios({
        method: 'get',
        url: GetPositionsByUnit(unitId)
    })
}
//获取多个文保单位的巡查点
export const getPositionsByUnits = (units: number[]) => {
    return tryAxios({
        method: 'post',
        url: GetMultiUnitPositions,
        data: units
    })
}
export const searchUsers = (teamId: number) => {
    return tryAxios({
        method: 'get',
        url: SearchUsers(teamId)
    })
}
export const getStatusList = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetStatusList,
        params: { type: firstType }
    })
}
export const getList = (param?: any) => {
    return tryAxios({
        method: 'get',
        url: GetList,
        params: param
    })
}

export const runTask = (planId: number) => {
    return tryAxios({
        method: 'post',
        url: RunTask(planId)
    })
}
export const stopData = (id: number) => {
    return tryAxios({
        method: 'post',
        url: Stop(id)
    })
}
export const openData = (id: number) => {
    return tryAxios({
        method: 'post',
        url: Open(id)
    })
}
export const getPendingTask = (planId: number) => {
    return tryAxios({
        method: 'get',
        url: GetPendingTask(planId)
    })
}
export const getTaskList = (planId: number) => {
    return tryAxios({
        method: 'get',
        url: GetTaskList(planId)
    })
}
export const closeData = (form: any) => {
    return tryAxios({
        method: 'post',
        url: Close,
        data: form
    })
}
export const removeData = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: Delete(id)
    })
}

export const getInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: Get(id)
    })
}

export const postData = (form: any) => {
    return tryAxios({
        method: 'post',
        url: Post,
        data: form
    })
}

export const putData = (id: number, form: any) => {
    return tryAxios({
        method: 'put',
        url: Put(id),
        data: form
    })
}
